const THEMATIC_AREAS = [
  {
    subtitle: '',
    title: 'MARKETING E COMUNICAZIONE'
  },
  {
    subtitle: '',
    title: 'GENERAL MANAGEMENT E GESTIONE DI IMPRESA'
  },
  {
    subtitle: '',
    title: 'HR, DE&I E DIRITTO DEL LAVORO'
  },
  {
    subtitle: '',
    title: 'AMMINISTRAZIONE, FINANZA E CONTROLLO'
  },
  {
    subtitle: '',
    title: 'FASHION & LUXURY'
  },
  {
    subtitle: '',
    title: 'EXPORT, SALES E RETAIL'
  },
  {
    subtitle: '',
    title: 'ESG, SOSTENIBILITÀ, ENERGIA E AMBIENTE'
  },
  {
    subtitle: '',
    title: 'SANITÀ E PHARMA'
  },
  {
    subtitle: '',
    title: 'ARTE, CULTURA, SPORT'
  },
  {
    subtitle: '',
    title: 'DIRITTO E FISCO'
  },
  {
    subtitle: '',
    title: 'FOOD, BEVERAGE E TURISMO'
  },
  {
    subtitle: '',
    title: 'PROJECT MANAGEMENT'
  },
  {
    subtitle: '',
    title: 'SOFT SKILLS'
  },
  {
    subtitle: '',
    title: 'DIGITAL TRANSFORMATION, TECNOLOGIE E INTELLIGENZA ARTIFICIALE'
  },
  {
    subtitle: '',
    title: 'PUBBLICA AMMINISTRAZIONE'
  },
];

const TRAINING_COURSES = [
  {
    subtitle: '10 ore',
    title: 'Analytics e Big Data'
  },
  {
    subtitle: '10 ore',
    title: 'Logistica e Supply Chain'
  },
  {
    subtitle: '15 ore',
    title: 'Project Management'
  },
  {
    subtitle: '15 ore',
    title: 'Soft Skills'
  },
  {
    subtitle: '15 ore',
    title: 'Cybersecurity e Data protection'
  },
  {
    subtitle: '15 ore',
    title: 'Digitalizzazione della PA'
  },
  {
    subtitle: '20 ore',
    title: 'Risorse Umane'
  },
  {
    subtitle: '25 ore',
    title: 'Sostenibilità ed energia'
  },
  {
    subtitle: '30 ore',
    title: 'Digital Transformation & Innovation'
  },
  {
    subtitle: '30 ore',
    title: 'Amministrazione, Finanza e controllo'
  },
  {
    subtitle: '40 ore',
    title: 'Pacchetto Office'
  }
]

const DEI_PROGRAM = [
  { subtitle: 'Masterclass 1', title: ' CSR e Scelte Aziendali' },
  { subtitle: 'Masterclass 2', title: ' Evoluzione Normativa e Certificazioni DE&I' },
  { subtitle: 'Masterclass 3', title: ' I Valori della Diversità' },
  { subtitle: 'Masterclass 4', title: ' Le Opportunità della Diversità' },
  { subtitle: 'Masterclass 5', title: ' L\'Impatto della Diversità per il Business' },
  { subtitle: 'Masterclass 6', title: ' Comunicare con linguaggi inclusivi' }
]

const PERCORSI_4W4I = [
  { 
    title: 'Progettati per contribuire allo sviluppo di una cultura aziendale orientata alla Diversity, Equity & Inclusion (DE&I).<br/><br/>Accessibili a tutti i membri dell\'organizzazione, mirano a diffondere la consapevolezza e l\'impegno nella DE&I.', 
    subtitle: ' PERCORSI ASINCRONI E ON DEMAND' 
  },
  { 
    title: 'Progettate per Manager, Responsabili HR, DE&I manager e DE&I Champion.<br/><br/>Offrono strumenti pratici e applicabili nell\'ambiente aziendale quotidiano.<br/><br/>Favoriscono l\'apprendimento e la condivisione di conoscenze, attraverso la discussione di casi reali e l\'apporto dei nostri esperti.<br/><br/>Si rivolgono a coloro che, indipendentemente dalla funzione o dal livello di seniority, sono responsabili della gestione di gruppi di persone.', 
    subtitle: 'MASTERCLASS' 
  },
  { 
    title: 'Sono progettati per fornire competenze avanzate necessarie per sviluppare e implementare strategie di DE&I in organizzazioni complesse.<br/><br/>Sono adatti a professionisti che ricoprono ruoli chiave all\'interno dell\'azienda e che sono incaricati di promuovere l\'equità e l\'inclusione nei processi organizzativi.', 
    subtitle: 'MASTER PART TIME' 
  }
]

const FACULTY_4W4I = [
  {
    name: "Simona Alini",
    role: "Partner & Head of Diversity & Inclusion",
    company: "GSO Company",
    bio: "",
    image: "/images/4w4i/faculty/alini.webp",
  },
  {
    name: "Annamaria Anelli",
    role: "Business Writer",
    company: "",
    bio: "",
    image: "/images/4w4i/faculty/anelli.webp",
  },
  {
    name: "Ciro Cafiero",
    role: "Avvocato Studio Legale",
    company: "Cafiero Pezzali & Associati",
    bio: "",
    image: "/images/4w4i/faculty/cafiero.webp",
  },
  {
    name: "Doriana De Benedictis",
    role: "Europe West Diversity&Inclusion Leader",
    company: "EY",
    bio: "",
    image: "/images/4w4i/faculty/debenedictis.webp",
  },
  {
    name: "Andrea Laudadio",
    role: "Responsabile TIM Academy & Development",
    company: "",
    bio: "",
    image: "/images/4w4i/faculty/.webp",
  },
  {
    name: "Sonia Malaspina",
    role: "Corporate Affairs, Communication & Sustainability Director",
    company: "Danone",
    bio: "",
    image: "/images/4w4i/faculty/.webp",
  },
  {
    name: "Matilde Marandola ",
    role: "Presidente AIDP",
    company: "Associazione Italiana per la Direzione del Personale",
    bio: "",
    image: "/images/4w4i/faculty/.webp",
  },
  {
    name: "Pier Maria Minuzzo",
    role: "People Development Director",
    company: "24ORE Business School",
    bio: "",
    image: "/images/4w4i/faculty/minuzzo.webp",
  },
  {
    name: "Najoua Meddad",
    role: "Consultant",
    company: "Mida",
    bio: "",
    image: "/images/4w4i/faculty/meddad.webp",
  }
]

const ADVANTAGES = [
  {
    subtitle: '',
    title: 'ADATTABILITÀ E PERTINENZA'
  },
  {
    subtitle: '',
    title: 'FLESSIBILITÀ NELL’APPRENDIMENTO E MASSIMA EFFICIENZA DEL TEMPO'
  },
  {
    subtitle: '',
    title: 'COINVOLGIMENTO E SODDISFAZIONE DEI DIPENDENTI'
  },
  {
    subtitle: '',
    title: 'RISPARMIO SUI COSTI A LUNGO TERMINE'
  }
];

export const B2BUtils = {
  THEMATIC_AREAS,
  TRAINING_COURSES,
  DEI_PROGRAM,
  PERCORSI_4W4I,
  FACULTY_4W4I,
  ADVANTAGES
};
